import {TOGGLE_NAVBAR} from "./actionTypes";

export const handleToggleNavbar = () => {
  return {
    type: TOGGLE_NAVBAR
  }
};

